import { Modal } from '@mantine/core';

import { ReactComponent as LeftArrowIcon } from 'assets/icons/orangeLeftArrow.svg';
import PrimaryButton from 'components/primaryButton';
import { Controller, useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import FileUpload from './fileUpload';

import useAddNewSubFolder from '../../hooks/useAddnewsubFolder';
import useGetIntoFolders from '../../hooks/useGetIntoFolder';
import { useEffect, useState } from 'react';

const AddANewFileModal = ({
  addSubFileModal,
  setAddSubFileModal,
  setLastUploadData,
  setlastgetData,
  isAllUploded,
  setIsallUploded,
}) => {
  const location = useLocation();
  const pathFilesAndFolders = useGetIntoFolders(location?.state?.path);

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  const closeModal = () => {
    setAddSubFileModal(false);
    reset({ file: '' });
    setSucessCount(0);
    setCountOfFiles(0);
    setIsallUploded(false);
  };

  const [successCount, setSucessCount] = useState(0);
  const [countofFiles, setCountOfFiles] = useState(0);
  const addANewFile = useAddNewSubFolder(
    closeModal,
    setCountOfFiles,
    countofFiles
  );

  const customTitle = () => {
    return (
      <div className='relative flex justify-center items-center text-xl mx-4 my-4'>
        <LeftArrowIcon
          onClick={() => {
            setAddSubFileModal(false);
            closeModal();
          }}
          className='w-4 absolute left-0 cursor-pointer'
        />
        <p>Upload a file</p>
      </div>
    );
  };

  const getErrorMessage = (name) => {
    return (
      errors[name] && (
        <p className=' text-sm font-semibold text-red-500'>
          {errors[name]?.message}
        </p>
      )
    );
  };

  useEffect(() => {
    if (successCount !== 0) {
      if (successCount === countofFiles) {
        setIsallUploded(false);
        closeModal();
      }
      setIsallUploded(true);
    }
    // eslint-disable-next-line
  }, [countofFiles, successCount]);

  const uploadFile = (data) => {
    setLastUploadData(data?.file);
    setSucessCount(data?.file?.length);
    setlastgetData(pathFilesAndFolders?.data?.data);
    // eslint-disable-next-line
    const updatedpaths = data?.file?.map(async (each) => {
      const formData = new FormData();
      formData.append('file', each);
      formData.append('path', location?.state?.path);
      addANewFile.mutate(formData);
    });
  };

  return (
    <Modal
      opened={addSubFileModal}
      onClose={closeModal}
      title={customTitle()}
      withCloseButton={false}
      overlayColor={'#F8F7F799'}
      overlayBlur={20}
      overlayOpacity={0.5}
      centered
      size={700}
      radius='md'
      overflow='inside'
      transitionDuration={100}
      classNames={{
        title: 'w-full  font-semibold text-18',
        modal: 'pl-10',
        body: 'scroller -mr-4 pr-2',
      }}
    >
      <form onSubmit={handleSubmit(uploadFile)}>
        <div className='py-2 w-full'>
          <Controller
            control={control}
            name='file'
            rules={{
              required: 'Required',
            }}
            render={({ field: { onChange } }) => (
              <FileUpload
                multiple={false}
                setImage={onChange}
                value={watch('file')}
              />
            )}
          />
          {getErrorMessage('certificate')}
        </div>
        {/* <UploadFileModal /> */}
        <div className='flex justify-center items-center my-5'>
          <button className=' w-28'>
            <PrimaryButton isLoading={isAllUploded}>Save</PrimaryButton>
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddANewFileModal;
